import React, { useState, useEffect } from 'react';
import "./footer.css";

function Footer(props) {
  return(
    <footer>
      <div className='shadow'></div>
      <small>Created by <a href="https://github.com/ufarqrobbany" target='_blank'>ufarqrobbany</a></small>
    </footer>
  );
}

export default Footer;
